import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigInt: { input: any; output: any };
  Date: { input: any; output: any };
  JSON: { input: any; output: any };
  Long: { input: any; output: any };
};

export type Activity = {
  bullets?: Maybe<Array<Maybe<ActivityBullet>>>;
  created_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  maxAge?: Maybe<Scalars['Int']['output']>;
  minAge?: Maybe<Scalars['Int']['output']>;
  sex?: Maybe<Sex>;
  skill?: Maybe<ActivitySkill>;
  status?: Maybe<GeneralStatus>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type ActivityArgs = {
  description: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  sex_id?: InputMaybe<Scalars['Int']['input']>;
  skill_id: Scalars['Int']['input'];
  status?: InputMaybe<GeneralStatus>;
  title: Scalars['String']['input'];
};

export type ActivityBullet = {
  created_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_order?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type ActivityFilter = {
  description?: InputMaybe<StringFilterOptions>;
  status?: InputMaybe<GeneralStatusFilterOptions>;
  title?: InputMaybe<StringFilterOptions>;
};

export type ActivityListResult = {
  data?: Maybe<Array<Maybe<Activity>>>;
  totalCount: Scalars['Int']['output'];
};

export type ActivityOrderFields = {
  created_at?: InputMaybe<Order>;
  description?: InputMaybe<Order>;
  title?: InputMaybe<Order>;
  updated_at?: InputMaybe<Order>;
};

export type ActivitySkill = {
  created_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type AiRawFile = {
  author?: Maybe<Author>;
  content_title?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  file_name: Scalars['String']['output'];
  file_object: FileObject;
  file_path: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  job_id?: Maybe<Scalars['String']['output']>;
  program?: Maybe<Program>;
  type?: Maybe<ContentType>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type AiRawFileArgs = {
  author_id: Scalars['Int']['input'];
  content_title?: InputMaybe<Scalars['String']['input']>;
  file_name: Scalars['String']['input'];
  file_path: Scalars['String']['input'];
  program_id: Scalars['Int']['input'];
  type: ContentType;
};

export type AiRawFileListResult = {
  data?: Maybe<Array<Maybe<AiRawFile>>>;
  totalCount: Scalars['Int']['output'];
};

export type AiRawFilePipelineStatus = {
  details?: Maybe<Scalars['JSON']['output']>;
  job_id?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type AppChangeLog = {
  created_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type AppConfig = {
  app_base_url?: Maybe<Scalars['String']['output']>;
  changeLogs?: Maybe<Array<Maybe<AppChangeLog>>>;
  created_at?: Maybe<Scalars['Date']['output']>;
  current_version?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  media_base_url?: Maybe<Scalars['String']['output']>;
  minimum_version?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type AppConfigInput = {
  app_base_url: Scalars['String']['input'];
  changeLogs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  current_version: Scalars['Int']['input'];
  media_base_url: Scalars['String']['input'];
  minimum_version: Scalars['Int']['input'];
};

export type AppConfigListResult = {
  data?: Maybe<Array<Maybe<AppConfig>>>;
  totalCount: Scalars['Int']['output'];
};

export type Author = {
  created_at?: Maybe<Scalars['Date']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  profile_image?: Maybe<Scalars['String']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type AuthorFilter = {
  first_name?: InputMaybe<StringFilterOptions>;
  last_name?: InputMaybe<StringFilterOptions>;
  profile_image?: InputMaybe<StringFilterOptions>;
  specialty?: InputMaybe<StringFilterOptions>;
};

export type AuthorInputArgs = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  profile_image?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorListResult = {
  data?: Maybe<Array<Maybe<Author>>>;
  totalCount: Scalars['Int']['output'];
};

export type AuthorOrderFields = {
  first_name?: InputMaybe<Order>;
  last_name?: InputMaybe<Order>;
  profile_image?: InputMaybe<Order>;
  specialty?: InputMaybe<Order>;
};

export type BooleanFilterOptions = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BotResponse = {
  conversation: Conversation;
  message: Message;
};

export type Bundle = {
  created_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_purchasable?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  price_before_discount?: Maybe<Scalars['Float']['output']>;
  programs?: Maybe<Array<Maybe<Program>>>;
  status?: Maybe<GeneralStatus>;
  summary?: Maybe<Scalars['String']['output']>;
  summary_en?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  thumbnail_path?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  title_en?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type BundleFilter = {
  created_at?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<StringFilterOptions>;
  is_purchasable?: InputMaybe<BooleanFilterOptions>;
  status?: InputMaybe<GeneralStatusFilterOptions>;
  title?: InputMaybe<StringFilterOptions>;
  updated_at?: InputMaybe<Scalars['Date']['input']>;
};

export type BundleInputArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  is_purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  price_before_discount?: InputMaybe<Scalars['Float']['input']>;
  program_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status?: InputMaybe<GeneralStatus>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_en?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  title_en?: InputMaybe<Scalars['String']['input']>;
};

export type BundleListResult = {
  data?: Maybe<Array<Maybe<Bundle>>>;
  totalCount: Scalars['Int']['output'];
};

export type BundleOrderFields = {
  created_at?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
  title?: InputMaybe<Order>;
  updated_at?: InputMaybe<Order>;
};

export type Category = {
  banner?: Maybe<Scalars['String']['output']>;
  category_id?: Maybe<Scalars['Int']['output']>;
  contents?: Maybe<ContentListResult>;
  created_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type CategoryArgs = {
  banner?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptor: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryFilter = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<StringFilterOptions>;
  descriptor?: InputMaybe<StringFilterOptions>;
  name?: InputMaybe<StringFilterOptions>;
  status?: InputMaybe<NumberFilterOptions>;
};

export type CategoryListResult = {
  data?: Maybe<Array<Maybe<Category>>>;
  totalCount: Scalars['Int']['output'];
};

export type CategoryOrderFields = {
  created_at?: InputMaybe<Order>;
  description?: InputMaybe<Order>;
  name?: InputMaybe<Order>;
  updated_at?: InputMaybe<Order>;
};

export type CategoryUpdateArgs = {
  banner?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
};

export type Content = {
  author?: Maybe<Author>;
  author_id?: Maybe<Scalars['Int']['output']>;
  categories?: Maybe<CategoryListResult>;
  created_at?: Maybe<Scalars['Date']['output']>;
  elastic_id?: Maybe<Scalars['String']['output']>;
  file_object?: Maybe<FileObject>;
  id?: Maybe<Scalars['Int']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  is_hottest?: Maybe<Scalars['Boolean']['output']>;
  maxAge?: Maybe<Scalars['Int']['output']>;
  minAge?: Maybe<Scalars['Int']['output']>;
  play_type?: Maybe<ContentPlayType>;
  program?: Maybe<Program>;
  sex?: Maybe<Sex>;
  sex_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ContentStatus>;
  summary?: Maybe<Scalars['String']['output']>;
  summary_en?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  thumbnail_path?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_en?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ContentType>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type ContentFilter = {
  author_id?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['Date']['input']>;
  is_hottest?: InputMaybe<BooleanFilterOptions>;
  maxAge?: InputMaybe<NumberFilterOptions>;
  minAge?: InputMaybe<NumberFilterOptions>;
  play_type?: InputMaybe<ContentPlayTypeFilterOptions>;
  program_id?: InputMaybe<Scalars['Int']['input']>;
  sex_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ContentStatusFilterOptions>;
  thumbnail_path?: InputMaybe<StringFilterOptions>;
  title?: InputMaybe<StringFilterOptions>;
  type?: InputMaybe<ContentType>;
  updated_at?: InputMaybe<Scalars['Date']['input']>;
};

export type ContentInputArgs = {
  author_id?: InputMaybe<Scalars['Int']['input']>;
  category_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  elastic_id?: InputMaybe<Scalars['String']['input']>;
  file_object?: InputMaybe<FileObjectArgs>;
  index?: InputMaybe<Scalars['Int']['input']>;
  is_hottest?: InputMaybe<Scalars['Boolean']['input']>;
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  minAge?: InputMaybe<Scalars['Int']['input']>;
  play_type?: InputMaybe<ContentPlayType>;
  program_id?: InputMaybe<Scalars['Int']['input']>;
  sex_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ContentStatus>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_en?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_en?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContentType>;
};

export type ContentListResult = {
  data?: Maybe<Array<Maybe<Content>>>;
  totalCount: Scalars['Int']['output'];
};

export type ContentOrderFields = {
  created_at?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
  thumbnail_path?: InputMaybe<Order>;
  title?: InputMaybe<Order>;
  type?: InputMaybe<Order>;
  updated_at?: InputMaybe<Order>;
};

export enum ContentPlayType {
  Free = 'FREE',
  SubReq = 'SUB_REQ',
}

export type ContentPlayTypeFilterOptions = {
  equals?: InputMaybe<ContentPlayType>;
  in?: InputMaybe<Array<InputMaybe<ContentPlayType>>>;
  not?: InputMaybe<ContentPlayType>;
  notIn?: InputMaybe<Array<InputMaybe<ContentPlayType>>>;
};

export enum ContentStatus {
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Published = 'PUBLISHED',
}

export type ContentStatusFilterOptions = {
  equals?: InputMaybe<ContentStatus>;
  in?: InputMaybe<Array<InputMaybe<ContentStatus>>>;
  not?: InputMaybe<ContentStatus>;
  notIn?: InputMaybe<Array<InputMaybe<ContentStatus>>>;
};

export enum ContentType {
  Aud = 'AUD',
  Pic = 'PIC',
  Text = 'TEXT',
  Vid = 'VID',
}

export type Conversation = {
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CreateActivityBulletArgs = {
  activity_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type CreatePageLayoutArgs = {
  descriptor: Scalars['String']['input'];
  status?: InputMaybe<GeneralStatus>;
};

export type CreateUserRoleArgs = {
  role_id: Scalars['Int']['input'];
  user_id: Scalars['Int']['input'];
};

export enum DataType {
  Bundle = 'BUNDLE',
  Category = 'CATEGORY',
  Free = 'FREE',
}

export type DateTimeFilterOptions = {
  equals?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type DeleteActivityBulletArgs = {
  activity_id: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type DepositArgs = {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  payment_gateway_id: Scalars['Int']['input'];
};

export type DepositArgsWithMarkets = {
  description?: InputMaybe<Scalars['String']['input']>;
  product_id: Scalars['String']['input'];
  purchases_token: Scalars['String']['input'];
  type: DepositMarketType;
};

export enum DepositEntityType {
  Bundle = 'BUNDLE',
  Program = 'PROGRAM',
  Subscription = 'SUBSCRIPTION',
  Token = 'TOKEN',
}

export enum DepositMarketType {
  Bazaar = 'BAZAAR',
  Myket = 'MYKET',
}

export type DepositToWalletAndPurchaseArgs = {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['Int']['input'];
  entityType: DepositEntityType;
  payment_gateway_id: Scalars['Int']['input'];
};

export type DepositToWalletResult = {
  amount: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type DeviceSession = {
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  ip_address?: Maybe<Scalars['String']['output']>;
  last_used_at?: Maybe<Scalars['Date']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
  visitor_id?: Maybe<Scalars['String']['output']>;
};

export enum EntityType {
  Bundle = 'BUNDLE',
  Content = 'CONTENT',
  Program = 'PROGRAM',
}

export type Event = {
  created_at?: Maybe<Scalars['Date']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  organizer?: Maybe<Scalars['String']['output']>;
  organizer_image?: Maybe<Scalars['String']['output']>;
  status?: Maybe<GeneralStatus>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type EventFilter = {
  created_at?: InputMaybe<Scalars['Date']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  organizer?: InputMaybe<StringFilterOptions>;
  organizer_image?: InputMaybe<StringFilterOptions>;
  status?: InputMaybe<GeneralStatusFilterOptions>;
  title?: InputMaybe<StringFilterOptions>;
  updated_at?: InputMaybe<Scalars['Date']['input']>;
};

export type EventInputArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  image: Scalars['String']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  organizer?: InputMaybe<Scalars['String']['input']>;
  organizer_image?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<GeneralStatus>;
  title: Scalars['String']['input'];
};

export type EventListResult = {
  data?: Maybe<Array<Maybe<Event>>>;
  totalCount: Scalars['Int']['output'];
};

export type EventOrderFields = {
  created_at?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
  title?: InputMaybe<Order>;
  updated_at?: InputMaybe<Order>;
};

export type FileObject = {
  created_at?: Maybe<Scalars['Date']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<FileObjectStatus>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type FileObjectArgs = {
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  status?: InputMaybe<FileObjectStatus>;
};

export enum FileObjectStatus {
  Cancel = 'CANCEL',
  Deleted = 'DELETED',
  Error = 'ERROR',
  Initiated = 'INITIATED',
  Transcoded = 'TRANSCODED',
  Transcoding = 'TRANSCODING',
  Uploaded = 'UPLOADED',
  Uploading = 'UPLOADING',
}

export type FloatFilterOptions = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export enum GeneralStatus {
  Deleted = 'DELETED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
}

export type GeneralStatusFilterOptions = {
  equals?: InputMaybe<GeneralStatus>;
  in?: InputMaybe<Array<InputMaybe<GeneralStatus>>>;
  not?: InputMaybe<GeneralStatus>;
  notIn?: InputMaybe<Array<InputMaybe<GeneralStatus>>>;
};

export type GenerateVoucherInputArgs = {
  bundle_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  count: Scalars['Int']['input'];
  discount_value: Scalars['Float']['input'];
  expiry_date?: InputMaybe<Scalars['Date']['input']>;
  plan_id?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  program_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  token_plan_id?: InputMaybe<Scalars['Int']['input']>;
  type: VoucherType;
};

export type GetParentTypesFilter = {
  gender?: InputMaybe<NumberFilterOptions>;
};

export enum ItemType {
  Bundle = 'BUNDLE',
  Content = 'CONTENT',
  Program = 'PROGRAM',
}

export type Kid = {
  birthdate?: Maybe<Scalars['Date']['output']>;
  childNumber?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isOnlyChild?: Maybe<Scalars['Int']['output']>;
  is_born?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<User>;
  parentType?: Maybe<ParentType>;
  parent_id: Scalars['Int']['output'];
  parent_type_id: Scalars['Int']['output'];
  profile_image?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type KidCreateArgs = {
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  childNumber?: InputMaybe<Scalars['Int']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  isOnlyChild?: InputMaybe<Scalars['Int']['input']>;
  is_born?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  parent_id: Scalars['Int']['input'];
  parent_type_id: Scalars['Int']['input'];
  profile_image?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type KidFilter = {
  birthdate?: InputMaybe<DateTimeFilterOptions>;
  childNumber?: InputMaybe<NumberFilterOptions>;
  created_at?: InputMaybe<DateTimeFilterOptions>;
  first_name?: InputMaybe<StringFilterOptions>;
  gender?: InputMaybe<NumberFilterOptions>;
  isOnlyChild?: InputMaybe<NumberFilterOptions>;
  is_born?: InputMaybe<NumberFilterOptions>;
  last_name?: InputMaybe<StringFilterOptions>;
  parent_id?: InputMaybe<NumberFilterOptions>;
  parent_type_id?: InputMaybe<NumberFilterOptions>;
  updated_at?: InputMaybe<DateTimeFilterOptions>;
};

export type KidListResult = {
  data?: Maybe<Array<Maybe<Kid>>>;
  totalCount: Scalars['Int']['output'];
};

export type KidOrderFields = {
  birthdate?: InputMaybe<Order>;
  childNumber?: InputMaybe<Order>;
  created_at?: InputMaybe<Order>;
  first_name?: InputMaybe<Order>;
  gender?: InputMaybe<Order>;
  isOnlyChild?: InputMaybe<Order>;
  last_name?: InputMaybe<Order>;
  updated_at?: InputMaybe<Order>;
};

export type KidUpdateArgs = {
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  childNumber?: InputMaybe<Scalars['Int']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  isOnlyChild?: InputMaybe<Scalars['Int']['input']>;
  is_born?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  parent_id: Scalars['Int']['input'];
  parent_type_id?: InputMaybe<Scalars['Int']['input']>;
  profile_image?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type Login = {
  access_token?: Maybe<Scalars['String']['output']>;
  is_setup?: Maybe<Scalars['Boolean']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
};

export type Message = {
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  sender_type: MessageSenderType;
  suggestions?: Maybe<Array<Maybe<MessageSuggestion>>>;
  text: Scalars['String']['output'];
};

export enum MessageSenderType {
  Bot = 'BOT',
  User = 'USER',
}

export type MessageSuggestion = {
  content_id?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['Float']['output']>;
  filepath: Scalars['String']['output'];
  start_time: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type Mutation = {
  addAiRawFile?: Maybe<AiRawFile>;
  createActivity?: Maybe<Activity>;
  createActivityBullet?: Maybe<ActivityBullet>;
  createAppConfig: AppConfig;
  createAuthor?: Maybe<Author>;
  createBundle?: Maybe<Bundle>;
  createCategory?: Maybe<Category>;
  createContent: Content;
  createEvent?: Maybe<Event>;
  createMyKid?: Maybe<Kid>;
  createPageLayout?: Maybe<PageLayout>;
  createPageRow?: Maybe<PageRow>;
  createParentType?: Maybe<ParentType>;
  createPlan?: Maybe<Plan>;
  createProgram?: Maybe<Program>;
  createPromotion?: Maybe<Promotion>;
  createRole?: Maybe<Role>;
  createTokenPlan?: Maybe<TokenPlan>;
  createUserRole?: Maybe<UserRole>;
  deleteActivity?: Maybe<Activity>;
  deleteActivityBullet?: Maybe<ActivityBullet>;
  deleteAuthorById?: Maybe<Author>;
  deleteBundleById?: Maybe<Bundle>;
  deleteCategory?: Maybe<Category>;
  deleteContent?: Maybe<Content>;
  deleteEventById?: Maybe<Event>;
  deleteMyKid?: Maybe<Kid>;
  deletePageLayout?: Maybe<PageLayout>;
  deletePageRow?: Maybe<PageRow>;
  deleteParentType?: Maybe<ParentType>;
  deletePlan?: Maybe<Plan>;
  deleteProgram?: Maybe<Program>;
  deletePromotionById?: Maybe<Promotion>;
  deleteRole?: Maybe<Role>;
  deleteStreamById?: Maybe<Stream>;
  deleteTokenPlan?: Maybe<TokenPlan>;
  deleteUser?: Maybe<User>;
  deleteUserRole?: Maybe<UserRole>;
  depositToWallet?: Maybe<DepositToWalletResult>;
  depositToWalletWithMarkets?: Maybe<DepositToWalletWithMarketsResult>;
  generateStream?: Maybe<Stream>;
  generateVouchers?: Maybe<VoucherListResult>;
  loginWithCode?: Maybe<Login>;
  loginWithTmt?: Maybe<Login>;
  logout: Scalars['Boolean']['output'];
  purchase?: Maybe<WalletTransactionResult>;
  refreshToken?: Maybe<Login>;
  removeContentFromElastic?: Maybe<Content>;
  requestLogin?: Maybe<SendSmsResult>;
  resentToPipeline?: Maybe<AiRawFile>;
  sendMessage: BotResponse;
  terminateDevice: Scalars['Boolean']['output'];
  terminateDeviceWithTmt: Scalars['Boolean']['output'];
  updateActivity?: Maybe<Activity>;
  updateActivityBullet?: Maybe<ActivityBullet>;
  updateAuthor?: Maybe<Author>;
  updateBundle?: Maybe<Bundle>;
  updateCategory?: Maybe<Category>;
  updateContent?: Maybe<Content>;
  updateEvent?: Maybe<Event>;
  updateFileObject?: Maybe<FileObject>;
  updateMyKid?: Maybe<Kid>;
  updatePageLayout?: Maybe<PageLayout>;
  updatePageRow?: Maybe<PageRow>;
  updateParentType?: Maybe<ParentType>;
  updatePlan?: Maybe<Plan>;
  updateProfile?: Maybe<User>;
  updateProgram?: Maybe<Program>;
  updatePromotion?: Maybe<Promotion>;
  updateRole?: Maybe<Role>;
  updateStream?: Maybe<Stream>;
  updateTokenPlan?: Maybe<TokenPlan>;
  updateUser?: Maybe<User>;
  upsertContentIsElastic?: Maybe<Content>;
};

export type MutationAddAiRawFileArgs = {
  body: AiRawFileArgs;
};

export type MutationCreateActivityArgs = {
  body: ActivityArgs;
};

export type MutationCreateActivityBulletArgs = {
  body: CreateActivityBulletArgs;
};

export type MutationCreateAppConfigArgs = {
  body: AppConfigInput;
};

export type MutationCreateAuthorArgs = {
  author: AuthorInputArgs;
};

export type MutationCreateBundleArgs = {
  body: BundleInputArgs;
};

export type MutationCreateCategoryArgs = {
  category?: InputMaybe<CategoryArgs>;
};

export type MutationCreateContentArgs = {
  content?: InputMaybe<ContentInputArgs>;
};

export type MutationCreateEventArgs = {
  body: EventInputArgs;
};

export type MutationCreateMyKidArgs = {
  kid: MyKidCreateArgs;
};

export type MutationCreatePageLayoutArgs = {
  body?: InputMaybe<CreatePageLayoutArgs>;
};

export type MutationCreatePageRowArgs = {
  body?: InputMaybe<PageRowArgs>;
};

export type MutationCreateParentTypeArgs = {
  body: ParentTypeArgs;
};

export type MutationCreatePlanArgs = {
  body: PlanInputArgs;
};

export type MutationCreateProgramArgs = {
  body?: InputMaybe<ProgramInputArgs>;
};

export type MutationCreatePromotionArgs = {
  body: PromotionInputArgs;
};

export type MutationCreateRoleArgs = {
  name: Scalars['String']['input'];
};

export type MutationCreateTokenPlanArgs = {
  body: TokenPlanInputArgs;
};

export type MutationCreateUserRoleArgs = {
  roleId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type MutationDeleteActivityArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteActivityBulletArgs = {
  body: DeleteActivityBulletArgs;
};

export type MutationDeleteAuthorByIdArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteBundleByIdArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteCategoryArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteContentArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteEventByIdArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteMyKidArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeletePageLayoutArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeletePageRowArgs = {
  id: Scalars['Int']['input'];
  page_id: Scalars['Int']['input'];
};

export type MutationDeleteParentTypeArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeletePlanArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteProgramArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeletePromotionByIdArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteRoleArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteStreamByIdArgs = {
  id: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type MutationDeleteTokenPlanArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteUserArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteUserRoleArgs = {
  userRoleId: Scalars['Int']['input'];
};

export type MutationDepositToWalletArgs = {
  data: DepositArgs;
};

export type MutationDepositToWalletWithMarketsArgs = {
  data: DepositArgsWithMarkets;
};

export type MutationGenerateStreamArgs = {
  stream: StreamArgs;
};

export type MutationGenerateVouchersArgs = {
  body: GenerateVoucherInputArgs;
};

export type MutationLoginWithCodeArgs = {
  code: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
};

export type MutationPurchaseArgs = {
  body: PurchaseInputs;
};

export type MutationRemoveContentFromElasticArgs = {
  id: Scalars['Int']['input'];
};

export type MutationRequestLoginArgs = {
  mobile: Scalars['String']['input'];
};

export type MutationResentToPipelineArgs = {
  id: Scalars['Int']['input'];
};

export type MutationSendMessageArgs = {
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};

export type MutationTerminateDeviceArgs = {
  deviceId: Scalars['ID']['input'];
};

export type MutationTerminateDeviceWithTmtArgs = {
  deviceId: Scalars['ID']['input'];
};

export type MutationUpdateActivityArgs = {
  body: ActivityArgs;
  id: Scalars['Int']['input'];
};

export type MutationUpdateActivityBulletArgs = {
  body: UpdateActivityBulletArgs;
};

export type MutationUpdateAuthorArgs = {
  author: AuthorInputArgs;
  id: Scalars['Int']['input'];
};

export type MutationUpdateBundleArgs = {
  body: BundleInputArgs;
  id: Scalars['Int']['input'];
};

export type MutationUpdateCategoryArgs = {
  category: CategoryUpdateArgs;
  id: Scalars['Int']['input'];
};

export type MutationUpdateContentArgs = {
  content?: InputMaybe<ContentInputArgs>;
  id: Scalars['Int']['input'];
};

export type MutationUpdateEventArgs = {
  body: EventInputArgs;
  id: Scalars['Int']['input'];
};

export type MutationUpdateFileObjectArgs = {
  data: FileObjectArgs;
  id: Scalars['Int']['input'];
};

export type MutationUpdateMyKidArgs = {
  id: Scalars['Int']['input'];
  kid: MyKidUpdateArgs;
};

export type MutationUpdatePageLayoutArgs = {
  body: UpdatePageLayoutArgs;
  id: Scalars['Int']['input'];
};

export type MutationUpdatePageRowArgs = {
  body: PageRowArgs;
  id: Scalars['Int']['input'];
};

export type MutationUpdateParentTypeArgs = {
  body: ParentTypeArgs;
  id: Scalars['Int']['input'];
};

export type MutationUpdatePlanArgs = {
  body: PlanInputArgs;
  id: Scalars['Int']['input'];
};

export type MutationUpdateProfileArgs = {
  data: ProfileUpdateArgs;
};

export type MutationUpdateProgramArgs = {
  body?: InputMaybe<ProgramInputArgs>;
  id: Scalars['Int']['input'];
};

export type MutationUpdatePromotionArgs = {
  body: PromotionInputArgs;
  id: Scalars['Int']['input'];
};

export type MutationUpdateRoleArgs = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type MutationUpdateStreamArgs = {
  id: Scalars['Int']['input'];
  stream: StreamArgs;
};

export type MutationUpdateTokenPlanArgs = {
  body: TokenPlanInputArgs;
  id: Scalars['Int']['input'];
};

export type MutationUpdateUserArgs = {
  id: Scalars['Int']['input'];
  user: UserArgs;
};

export type MutationUpsertContentIsElasticArgs = {
  id: Scalars['Int']['input'];
};

export type MyKidCreateArgs = {
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  childNumber?: InputMaybe<Scalars['Int']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  isOnlyChild?: InputMaybe<Scalars['Int']['input']>;
  is_born?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  parent_type_id: Scalars['Int']['input'];
  profile_image?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type MyKidUpdateArgs = {
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  childNumber?: InputMaybe<Scalars['Int']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  isOnlyChild?: InputMaybe<Scalars['Int']['input']>;
  is_born?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  parent_type_id: Scalars['Int']['input'];
  profile_image?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Int']['input']>;
  week?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['String']['input']>;
};

export type NumberFilterOptions = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum Order {
  Asc = 'asc',
  Desc = 'desc',
}

export type Page = {
  created_at?: Maybe<Scalars['Date']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<Row>>>;
  status?: Maybe<GeneralStatus>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type PageFilter = {
  descriptor?: InputMaybe<StringFilterOptions>;
  status?: InputMaybe<GeneralStatusFilterOptions>;
};

export type PageLayout = {
  created_at?: Maybe<Scalars['Date']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  rows?: Maybe<Array<Maybe<PageRow>>>;
  status?: Maybe<GeneralStatus>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type PageLayoutFilter = {
  descriptor?: InputMaybe<StringFilterOptions>;
  status?: InputMaybe<GeneralStatusFilterOptions>;
};

export type PageLayoutListResult = {
  data?: Maybe<Array<Maybe<PageLayout>>>;
  totalCount: Scalars['Int']['output'];
};

export type PageLayoutOrderFields = {
  created_at?: InputMaybe<Order>;
  descriptor?: InputMaybe<Order>;
  updated_at?: InputMaybe<Order>;
};

export enum PageLayoutType {
  Carousel = 'CAROUSEL',
}

export type PageListResult = {
  data?: Maybe<Array<Maybe<Page>>>;
  totalCount: Scalars['Int']['output'];
};

export type PageOrderFields = {
  created_at?: InputMaybe<Order>;
  descriptor?: InputMaybe<Order>;
  updated_at?: InputMaybe<Order>;
};

export type PageRow = {
  created_at?: Maybe<Scalars['Date']['output']>;
  data_type?: Maybe<PageRowDataType>;
  id?: Maybe<Scalars['Int']['output']>;
  item_id?: Maybe<Scalars['String']['output']>;
  item_type?: Maybe<PageRowItemType>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PageLayoutType>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PageRowArgs = {
  data_type?: InputMaybe<PageRowDataType>;
  item_id?: InputMaybe<Scalars['String']['input']>;
  item_type?: InputMaybe<PageRowItemType>;
  order?: InputMaybe<Scalars['Int']['input']>;
  page_id: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PageLayoutType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum PageRowDataType {
  Bundle = 'BUNDLE',
  Category = 'CATEGORY',
  Free = 'FREE',
}

export enum PageRowItemType {
  Bundle = 'BUNDLE',
  Content = 'CONTENT',
  Program = 'PROGRAM',
}

export type PageRowListResult = {
  data?: Maybe<Array<Maybe<PageRow>>>;
  totalCount: Scalars['Int']['output'];
};

export enum PageType {
  Carousel = 'CAROUSEL',
}

export type ParentType = {
  gender?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ParentTypeArgs = {
  gender: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type ParentTypeListResult = {
  data?: Maybe<Array<ParentType>>;
  totalCount: Scalars['Int']['output'];
};

export type PaymentGateway = {
  id?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Plan = {
  created_at: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration_days: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  price_before_discount?: Maybe<Scalars['Float']['output']>;
  status: GeneralStatus;
  tax: Scalars['Float']['output'];
  type: PlanType;
  updated_at: Scalars['Date']['output'];
};

export type PlanInputArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  duration_days: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  price_before_discount?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<GeneralStatus>;
  type?: InputMaybe<PlanType>;
};

export type PlanListResult = {
  data?: Maybe<Array<Maybe<Plan>>>;
  totalCount: Scalars['Int']['output'];
};

export enum PlanType {
  WithoutMamanYar = 'WITHOUT_MAMAN_YAR',
  WithMamanYar = 'WITH_MAMAN_YAR',
}

export type PregnancyStatus = {
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProfileUpdateArgs = {
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  number_of_children?: InputMaybe<Scalars['Int']['input']>;
  pregnancy_status_id?: InputMaybe<Scalars['Int']['input']>;
  pregnancy_week?: InputMaybe<Scalars['Int']['input']>;
};

export type Program = {
  categories?: Maybe<Array<Maybe<Category>>>;
  created_at?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_hottest?: Maybe<Scalars['Boolean']['output']>;
  is_purchasable?: Maybe<Scalars['Boolean']['output']>;
  is_solitary?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  price_before_discount?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<GeneralStatus>;
  summary?: Maybe<Scalars['String']['output']>;
  summary_en?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  thumbnail_path?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_en?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type ProgramFilter = {
  created_at?: InputMaybe<Scalars['Date']['input']>;
  is_hottest?: InputMaybe<BooleanFilterOptions>;
  is_solitary?: InputMaybe<BooleanFilterOptions>;
  status?: InputMaybe<GeneralStatusFilterOptions>;
  title?: InputMaybe<StringFilterOptions>;
  updated_at?: InputMaybe<Scalars['Date']['input']>;
};

export type ProgramInputArgs = {
  category_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  is_hottest?: InputMaybe<Scalars['Boolean']['input']>;
  is_purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  is_solitary?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  price_before_discount?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<GeneralStatus>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_en?: InputMaybe<Scalars['String']['input']>;
  thumbnail_path?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  title_en?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramListResult = {
  data?: Maybe<Array<Maybe<Program>>>;
  totalCount: Scalars['Int']['output'];
};

export type ProgramOrderFields = {
  created_at?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
  title?: InputMaybe<Order>;
  updated_at?: InputMaybe<Order>;
};

export type Promotion = {
  created_at: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  status: GeneralStatus;
  title: Scalars['String']['output'];
  updated_at: Scalars['Date']['output'];
};

export type PromotionFilter = {
  created_at?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<StringFilterOptions>;
  link?: InputMaybe<StringFilterOptions>;
  status?: InputMaybe<GeneralStatusFilterOptions>;
  title?: InputMaybe<StringFilterOptions>;
  updated_at?: InputMaybe<Scalars['Date']['input']>;
};

export type PromotionInputArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  status?: InputMaybe<GeneralStatus>;
  title: Scalars['String']['input'];
};

export type PromotionListResult = {
  data?: Maybe<Array<Maybe<Promotion>>>;
  totalCount: Scalars['Int']['output'];
};

export type PromotionOrderFields = {
  created_at?: InputMaybe<Order>;
  order?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
  title?: InputMaybe<Order>;
  updated_at?: InputMaybe<Order>;
};

export type Purchase = {
  bundle?: Maybe<Bundle>;
  created_at: Scalars['Date']['output'];
  end_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  plan?: Maybe<Plan>;
  program?: Maybe<Program>;
  start_date?: Maybe<Scalars['Date']['output']>;
  status: PurchaseStatus;
  token_plan?: Maybe<TokenPlan>;
  transaction: WalletTransaction;
  type: PurchaseType;
  updated_at: Scalars['Date']['output'];
  voucher?: Maybe<Voucher>;
};

export type PurchaseArgs = {
  bundle_id?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['Date']['output']>;
  plan_id?: Maybe<Scalars['Int']['output']>;
  program_id?: Maybe<Scalars['Int']['output']>;
  start_date?: Maybe<Scalars['Date']['output']>;
  token_plan_id?: Maybe<Scalars['Int']['output']>;
  type: PurchaseType;
  voucher_id?: Maybe<Scalars['Int']['output']>;
};

export type PurchaseFilter = {
  type?: InputMaybe<PurchaseTypeFilterOptions>;
};

export type PurchaseInputs = {
  bundle_id?: InputMaybe<Scalars['Int']['input']>;
  plan_id?: InputMaybe<Scalars['Int']['input']>;
  program_id?: InputMaybe<Scalars['Int']['input']>;
  token_plan_id?: InputMaybe<Scalars['Int']['input']>;
  type: PurchaseType;
  voucher_code?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseListResult = {
  data?: Maybe<Array<Maybe<Purchase>>>;
  totalCount: Scalars['Int']['output'];
};

export enum PurchaseStatus {
  Canceled = 'CANCELED',
  Paid = 'PAID',
  Pending = 'PENDING',
}

export enum PurchaseType {
  Bundle = 'BUNDLE',
  Program = 'PROGRAM',
  Subscription = 'SUBSCRIPTION',
  Token = 'TOKEN',
}

export type PurchaseTypeFilterOptions = {
  equals?: InputMaybe<PurchaseType>;
  in?: InputMaybe<Array<InputMaybe<PurchaseType>>>;
  not?: InputMaybe<PurchaseType>;
  notIn?: InputMaybe<Array<InputMaybe<PurchaseType>>>;
};

export type Query = {
  checkValidationVoucher?: Maybe<Voucher>;
  getActiveBundleById?: Maybe<Bundle>;
  getActiveBundles?: Maybe<BundleListResult>;
  getActiveProgramById?: Maybe<Program>;
  getActivities?: Maybe<ActivityListResult>;
  getActivityById?: Maybe<Activity>;
  getActivitySkills?: Maybe<Array<Maybe<ActivitySkill>>>;
  getAiRawFiles?: Maybe<AiRawFileListResult>;
  getAppConfig: AppConfig;
  getAppConfigList?: Maybe<AppConfigListResult>;
  getAuthorById?: Maybe<Author>;
  getAuthors?: Maybe<AuthorListResult>;
  getBundleById?: Maybe<Bundle>;
  getBundles?: Maybe<BundleListResult>;
  getCategories?: Maybe<CategoryListResult>;
  getCategoryByDescriptor?: Maybe<Category>;
  getCategoryById?: Maybe<Category>;
  getContentById?: Maybe<Content>;
  getContents?: Maybe<ContentListResult>;
  getContentsByCategoryDescriptor?: Maybe<ContentListResult>;
  getContentsByProgramId?: Maybe<ContentListResult>;
  getConversations: Array<Conversation>;
  getEventById?: Maybe<Event>;
  getEvents?: Maybe<EventListResult>;
  getFileObjectById?: Maybe<FileObject>;
  getFreePublishedContents?: Maybe<ContentListResult>;
  getKidById?: Maybe<Kid>;
  getKids?: Maybe<KidListResult>;
  getMessages: Array<Message>;
  getMyDevices: Array<DeviceSession>;
  getMyDevicesWithTmt: Array<DeviceSession>;
  getMyKids?: Maybe<KidListResult>;
  getMyPurchases?: Maybe<PurchaseListResult>;
  getMyWallet?: Maybe<Wallet>;
  /** @deprecated This query is deprecated. Please use getPageLayout query. */
  getPageByDescriptor?: Maybe<Page>;
  getPageLayout?: Maybe<PageLayout>;
  getPageLayoutById?: Maybe<PageLayout>;
  getPageLayouts?: Maybe<PageLayoutListResult>;
  getParentTypeById?: Maybe<ParentType>;
  getParentTypes?: Maybe<ParentTypeListResult>;
  getPaymentGateways?: Maybe<Array<Maybe<PaymentGateway>>>;
  getPlanById?: Maybe<Plan>;
  getPlans?: Maybe<PlanListResult>;
  getPregnancyStatuses?: Maybe<Array<Maybe<PregnancyStatus>>>;
  getProfile?: Maybe<User>;
  getProgramById?: Maybe<Program>;
  getPrograms?: Maybe<ProgramListResult>;
  getProgramsByCategoryDescriptor?: Maybe<ProgramListResult>;
  getPromotionById?: Maybe<Promotion>;
  getPromotions?: Maybe<PromotionListResult>;
  getPublishedContentById?: Maybe<Content>;
  getSearchResult?: Maybe<Search>;
  getStatusOfPipeline?: Maybe<AiRawFilePipelineStatus>;
  getStreamById?: Maybe<Stream>;
  getStreamList?: Maybe<StreamListResult>;
  getSuggestionQuestions: Array<SuggestionQuestion>;
  getTokenPlanById?: Maybe<TokenPlan>;
  getTokenPlans?: Maybe<TokenPlanListResult>;
  getUserById?: Maybe<User>;
  getUserEvents?: Maybe<EventListResult>;
  getUserPromotions?: Maybe<PromotionListResult>;
  getUserTokenBalance: Scalars['Int']['output'];
  getUserWallet?: Maybe<Wallet>;
  getUserWalletTransactions?: Maybe<WalletTransactionListResult>;
  getUsers?: Maybe<UserListResult>;
  getVisitorId: Scalars['String']['output'];
  getVouchers?: Maybe<VoucherListResult>;
  getWalletChargeConfigs?: Maybe<Array<Maybe<WalletChargeResult>>>;
  getWalletTransactionById?: Maybe<WalletTransaction>;
  getWalletTransactions?: Maybe<WalletTransactionListResult>;
  requestLoginWithGoogle?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<RoleListResult>;
  transcodeFile?: Maybe<TranscodeResponse>;
  userHaveAccessToEntity?: Maybe<Scalars['Boolean']['output']>;
  userRoleById?: Maybe<Array<Maybe<UserRole>>>;
  usersRoles?: Maybe<UserRoleListResult>;
};

export type QueryCheckValidationVoucherArgs = {
  code: Scalars['String']['input'];
  type: Array<VoucherType>;
};

export type QueryGetActiveBundleByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetActiveBundlesArgs = {
  filter?: InputMaybe<BundleFilter>;
  orderBy?: InputMaybe<BundleOrderFields>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetActiveProgramByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetActivitiesArgs = {
  filter?: InputMaybe<ActivityFilter>;
  orderBy?: InputMaybe<ActivityOrderFields>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetActivityByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetAiRawFilesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetAppConfigListArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetAuthorByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetAuthorsArgs = {
  filter?: InputMaybe<AuthorFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<AuthorOrderFields>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetBundleByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetBundlesArgs = {
  filter?: InputMaybe<BundleFilter>;
  orderBy?: InputMaybe<BundleOrderFields>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetCategoriesArgs = {
  filter?: InputMaybe<CategoryFilter>;
  orderBy?: InputMaybe<CategoryOrderFields>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetCategoryByDescriptorArgs = {
  descriptor: Scalars['String']['input'];
};

export type QueryGetCategoryByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetContentByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetContentsArgs = {
  filter?: InputMaybe<ContentFilter>;
  orderBy?: InputMaybe<ContentOrderFields>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetContentsByCategoryDescriptorArgs = {
  categoryDescriptor: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetContentsByProgramIdArgs = {
  id: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetConversationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetEventByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetEventsArgs = {
  filter?: InputMaybe<EventFilter>;
  orderBy?: InputMaybe<EventOrderFields>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetFileObjectByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetFreePublishedContentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetKidByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetKidsArgs = {
  filter?: InputMaybe<KidFilter>;
  orderBy?: InputMaybe<Array<InputMaybe<KidOrderFields>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetMessagesArgs = {
  conversationId: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetMyPurchasesArgs = {
  filter?: InputMaybe<PurchaseFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetPageByDescriptorArgs = {
  descriptor: Scalars['String']['input'];
};

export type QueryGetPageLayoutArgs = {
  descriptor: Scalars['String']['input'];
};

export type QueryGetPageLayoutByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetPageLayoutsArgs = {
  filter?: InputMaybe<PageLayoutFilter>;
  orderBy?: InputMaybe<PageLayoutOrderFields>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetParentTypeByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetParentTypesArgs = {
  filter?: InputMaybe<GetParentTypesFilter>;
};

export type QueryGetPlanByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetProgramByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetProgramsArgs = {
  filter?: InputMaybe<ProgramFilter>;
  orderBy?: InputMaybe<ProgramOrderFields>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetProgramsByCategoryDescriptorArgs = {
  categoryDescriptor: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetPromotionByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetPromotionsArgs = {
  filter?: InputMaybe<PromotionFilter>;
  orderBy?: InputMaybe<PromotionOrderFields>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetPublishedContentByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetSearchResultArgs = {
  text: Scalars['String']['input'];
};

export type QueryGetStatusOfPipelineArgs = {
  job_id: Scalars['String']['input'];
};

export type QueryGetStreamByIdArgs = {
  id: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type QueryGetStreamListArgs = {
  userId: Scalars['Int']['input'];
};

export type QueryGetTokenPlanByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetUserByIdArgs = {
  id: Scalars['Int']['input'];
};

export type QueryGetUserEventsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetUserPromotionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetUserWalletArgs = {
  userId: Scalars['Int']['input'];
};

export type QueryGetUserWalletTransactionsArgs = {
  filter?: InputMaybe<WalletTransactionFilter>;
  orderBy?: InputMaybe<WalletTransactionOrderFields>;
  page?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type QueryGetUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  orderBy?: InputMaybe<UserOrderFields>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetVouchersArgs = {
  filter?: InputMaybe<VoucherFilter>;
  orderBy?: InputMaybe<VoucherOrderFields>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetWalletTransactionByIdArgs = {
  id: Scalars['String']['input'];
};

export type QueryGetWalletTransactionsArgs = {
  filter?: InputMaybe<WalletTransactionFilter>;
  orderBy?: InputMaybe<WalletTransactionOrderFields>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTranscodeFileArgs = {
  id: Scalars['Int']['input'];
};

export type QueryUserHaveAccessToEntityArgs = {
  body?: InputMaybe<UserHaveAccessInputArgs>;
};

export type QueryUserRoleByIdArgs = {
  userId: Scalars['Int']['input'];
};

export type QueryUsersRolesArgs = {
  filter?: InputMaybe<UserRoleFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type RadeAiChatBotResponse = {
  documents?: Maybe<Scalars['JSON']['output']>;
  response?: Maybe<Scalars['String']['output']>;
};

export type Role = {
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RoleListResult = {
  data?: Maybe<Array<Maybe<Role>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Row = {
  created_at?: Maybe<Scalars['Date']['output']>;
  dataType?: Maybe<DataType>;
  id?: Maybe<Scalars['Int']['output']>;
  itemDescriptor?: Maybe<Scalars['String']['output']>;
  itemType?: Maybe<ItemType>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PageType>;
  updated_at?: Maybe<Scalars['Date']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type RowListResult = {
  data?: Maybe<Array<Maybe<Row>>>;
  totalCount: Scalars['Int']['output'];
};

export type Search = {
  categories?: Maybe<Array<Maybe<Category>>>;
  contentMatches?: Maybe<Array<Maybe<Content>>>;
  titleMatches?: Maybe<Array<Maybe<Content>>>;
};

export type SendSmsResult = {
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type Sex = {
  id: Scalars['Int']['output'];
  sex: Scalars['String']['output'];
};

export type Stream = {
  created_at?: Maybe<Scalars['Date']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  port?: Maybe<Scalars['String']['output']>;
  stream_key?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type StreamArgs = {
  host?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type StreamListResult = {
  data?: Maybe<Array<Maybe<Stream>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StringFilterOptions = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestionQuestion = {
  id: Scalars['Int']['output'];
  question: Scalars['String']['output'];
};

export type TokenPlan = {
  count: Scalars['Int']['output'];
  created_at: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  price_before_discount?: Maybe<Scalars['Float']['output']>;
  status: GeneralStatus;
  tax: Scalars['Float']['output'];
  updated_at: Scalars['Date']['output'];
};

export type TokenPlanInputArgs = {
  count: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  price_before_discount?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<GeneralStatus>;
};

export type TokenPlanListResult = {
  data?: Maybe<Array<Maybe<TokenPlan>>>;
  totalCount: Scalars['Int']['output'];
};

export type TransactionArgs = {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type: WalletTransactionType;
};

export type TranscodeResponse = {
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateActivityBulletArgs = {
  activity_id: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  display_order?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type UpdatePageLayoutArgs = {
  status?: InputMaybe<GeneralStatus>;
};

export type User = {
  activity_notification_status?: Maybe<Scalars['Int']['output']>;
  birthdate?: Maybe<Scalars['Date']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  game_notification_status?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  number_of_children?: Maybe<Scalars['Int']['output']>;
  parent_type_id?: Maybe<Scalars['Int']['output']>;
  pregnancy_status_id?: Maybe<Scalars['Int']['output']>;
  pregnancy_week?: Maybe<Scalars['Int']['output']>;
  profile_image?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<UserRoleListResult>;
  status?: Maybe<Scalars['Int']['output']>;
  token_balance?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type UserArgs = {
  activity_notification_status?: InputMaybe<Scalars['Int']['input']>;
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  game_notification_status?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  number_of_children?: InputMaybe<Scalars['Int']['input']>;
  parent_type_id?: InputMaybe<Scalars['Int']['input']>;
  pregnancy_status_id?: InputMaybe<Scalars['Int']['input']>;
  pregnancy_week?: InputMaybe<Scalars['Int']['input']>;
  role_ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status?: InputMaybe<Scalars['Int']['input']>;
};

export enum UserCreateArgRole {
  Admin = 'admin',
  Superadmin = 'superadmin',
  User = 'user',
}

export type UserFilter = {
  created_at?: InputMaybe<StringFilterOptions>;
  email?: InputMaybe<StringFilterOptions>;
  first_name?: InputMaybe<StringFilterOptions>;
  last_name?: InputMaybe<StringFilterOptions>;
  mobile?: InputMaybe<StringFilterOptions>;
  updated_at?: InputMaybe<StringFilterOptions>;
};

export type UserHaveAccessInputArgs = {
  entityId: Scalars['Int']['input'];
  entityType: EntityType;
};

export type UserListResult = {
  data?: Maybe<Array<Maybe<User>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserOrderFields = {
  created_at?: InputMaybe<Order>;
  email?: InputMaybe<Order>;
  first_name?: InputMaybe<Order>;
  last_name?: InputMaybe<Order>;
  mobile?: InputMaybe<Order>;
  updated_at?: InputMaybe<Order>;
};

export type UserRole = {
  created_at?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  role?: Maybe<Role>;
  role_id: Scalars['Int']['output'];
  updated_at?: Maybe<Scalars['Date']['output']>;
  user_id: Scalars['Int']['output'];
};

export type UserRoleFilter = {
  role_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UserRoleListResult = {
  data?: Maybe<Array<Maybe<UserRole>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Voucher = {
  bundles?: Maybe<Array<Maybe<Bundle>>>;
  code: Scalars['String']['output'];
  created_at: Scalars['Date']['output'];
  discount_value: Scalars['Float']['output'];
  expiry_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  plan?: Maybe<Plan>;
  programs?: Maybe<Array<Maybe<Program>>>;
  status: VoucherStatus;
  token_plan?: Maybe<TokenPlan>;
  type: VoucherType;
  updated_at: Scalars['Date']['output'];
};

export type VoucherFilter = {
  bundle_id?: InputMaybe<NumberFilterOptions>;
  code?: InputMaybe<StringFilterOptions>;
  plan_id?: InputMaybe<NumberFilterOptions>;
  program_id?: InputMaybe<NumberFilterOptions>;
  status?: InputMaybe<VoucherStatusFilterOptions>;
  token_plan_id?: InputMaybe<NumberFilterOptions>;
  type?: InputMaybe<VoucherTypeFilterOptions>;
};

export type VoucherListResult = {
  data?: Maybe<Array<Maybe<Voucher>>>;
  totalCount: Scalars['Int']['output'];
};

export type VoucherOrderFields = {
  code?: InputMaybe<Order>;
  created_at?: InputMaybe<Order>;
  discount_value?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
  type?: InputMaybe<Order>;
};

export enum VoucherStatus {
  Available = 'AVAILABLE',
  Expired = 'EXPIRED',
  Reserved = 'RESERVED',
  Used = 'USED',
}

export type VoucherStatusFilterOptions = {
  equals?: InputMaybe<VoucherStatus>;
  in?: InputMaybe<Array<InputMaybe<VoucherStatus>>>;
  not?: InputMaybe<VoucherStatus>;
  notIn?: InputMaybe<Array<InputMaybe<VoucherStatus>>>;
};

export enum VoucherType {
  Bundle = 'BUNDLE',
  Program = 'PROGRAM',
  Subscription = 'SUBSCRIPTION',
  Token = 'TOKEN',
}

export type VoucherTypeFilterOptions = {
  equals?: InputMaybe<VoucherType>;
  in?: InputMaybe<Array<InputMaybe<VoucherType>>>;
  not?: InputMaybe<VoucherType>;
  notIn?: InputMaybe<Array<InputMaybe<VoucherType>>>;
};

export type Wallet = {
  balance?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['Date']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type WalletChargeResult = {
  amount: Scalars['Int']['output'];
  descriptor: Scalars['String']['output'];
};

export type WalletTransaction = {
  amount: Scalars['Float']['output'];
  created_at?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status: WalletTransactionStatus;
  type: WalletTransactionType;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type WalletTransactionFilter = {
  amount?: InputMaybe<FloatFilterOptions>;
  status?: InputMaybe<WalletTransactionStatusFilterOptions>;
  type?: InputMaybe<WalletTransactionTypeFilterOptions>;
};

export type WalletTransactionListResult = {
  data?: Maybe<Array<Maybe<WalletTransaction>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type WalletTransactionOrderFields = {
  amount?: InputMaybe<Order>;
  created_at?: InputMaybe<Order>;
  status?: InputMaybe<Order>;
  type?: InputMaybe<Order>;
};

export type WalletTransactionResult = {
  message?: Maybe<Scalars['String']['output']>;
  new_balance?: Maybe<Scalars['Float']['output']>;
  transaction?: Maybe<WalletTransaction>;
};

export enum WalletTransactionStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
}

export type WalletTransactionStatusFilterOptions = {
  equals?: InputMaybe<WalletTransactionStatus>;
  in?: InputMaybe<Array<InputMaybe<WalletTransactionStatus>>>;
  not?: InputMaybe<WalletTransactionStatus>;
  notIn?: InputMaybe<Array<InputMaybe<WalletTransactionStatus>>>;
};

export enum WalletTransactionType {
  Bonus = 'BONUS',
  BundlePurchase = 'BUNDLE_PURCHASE',
  Deposit = 'DEPOSIT',
  ProgramPurchase = 'PROGRAM_PURCHASE',
  SubscriptionPurchase = 'SUBSCRIPTION_PURCHASE',
  TokenPurchase = 'TOKEN_PURCHASE',
}

export type WalletTransactionTypeFilterOptions = {
  equals?: InputMaybe<WalletTransactionType>;
  in?: InputMaybe<Array<InputMaybe<WalletTransactionType>>>;
  not?: InputMaybe<WalletTransactionType>;
  notIn?: InputMaybe<Array<InputMaybe<WalletTransactionType>>>;
};

export type DepositToWalletWithMarketsResult = {
  result?: Maybe<Scalars['String']['output']>;
};

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never }>;

export type RefreshTokenMutation = {
  refreshToken?: { access_token?: string | null; refresh_token?: string | null } | null;
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = { logout: boolean };

export type RequestLoginMutationVariables = Exact<{
  mobile: Scalars['String']['input'];
}>;

export type RequestLoginMutation = {
  requestLogin?: { message?: string | null; status?: number | null } | null;
};

export type LoginWithCodeMutationVariables = Exact<{
  mobile: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;

export type LoginWithCodeMutation = {
  loginWithCode?: {
    access_token?: string | null;
    refresh_token?: string | null;
    is_setup?: boolean | null;
  } | null;
};

export type LoginWithTmtMutationVariables = Exact<{ [key: string]: never }>;

export type LoginWithTmtMutation = {
  loginWithTmt?: {
    access_token?: string | null;
    refresh_token?: string | null;
    is_setup?: boolean | null;
  } | null;
};

export type GetMyDevicesWithTempTokenQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyDevicesWithTempTokenQuery = {
  getMyDevicesWithTmt: Array<{
    id: string;
    source?: string | null;
    user_agent?: string | null;
    ip_address?: string | null;
    visitor_id?: string | null;
    metadata?: any | null;
    created_at?: any | null;
    last_used_at?: any | null;
  }>;
};

export type GetMyDevicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyDevicesQuery = {
  getMyDevices: Array<{
    id: string;
    source?: string | null;
    user_agent?: string | null;
    ip_address?: string | null;
    visitor_id?: string | null;
    metadata?: any | null;
    created_at?: any | null;
    last_used_at?: any | null;
  }>;
};

export type GetVisitorIdQueryVariables = Exact<{ [key: string]: never }>;

export type GetVisitorIdQuery = { getVisitorId: string };

export type TerminateDeviceSessionWithTempTokenMutationVariables = Exact<{
  deviceId: Scalars['ID']['input'];
}>;

export type TerminateDeviceSessionWithTempTokenMutation = { terminateDeviceWithTmt: boolean };

export type TerminateDeviceSessionMutationVariables = Exact<{
  deviceId: Scalars['ID']['input'];
}>;

export type TerminateDeviceSessionMutation = { terminateDevice: boolean };

export type RequestLoginWithGoogleQueryVariables = Exact<{ [key: string]: never }>;

export type RequestLoginWithGoogleQuery = { requestLoginWithGoogle?: string | null };

export type GetBundlesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<BundleFilter>;
  orderBy?: InputMaybe<BundleOrderFields>;
}>;

export type GetBundlesQuery = {
  getActiveBundles?: {
    totalCount: number;
    data?: Array<{
      id: number;
      title: string;
      title_en?: string | null;
      summary?: string | null;
      summary_en?: string | null;
      description?: string | null;
      thumbnail_path?: string | null;
      is_purchasable?: boolean | null;
      tax?: number | null;
      price?: number | null;
      price_before_discount?: number | null;
      status?: GeneralStatus | null;
      created_at?: any | null;
      updated_at?: any | null;
    } | null> | null;
  } | null;
};

export type GetBundleByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type GetBundleByIdQuery = {
  getActiveBundleById?: {
    id: number;
    title: string;
    title_en?: string | null;
    summary?: string | null;
    summary_en?: string | null;
    description?: string | null;
    thumbnail_path?: string | null;
    is_purchasable?: boolean | null;
    tax?: number | null;
    price?: number | null;
    price_before_discount?: number | null;
    status?: GeneralStatus | null;
    created_at?: any | null;
    updated_at?: any | null;
    programs?: Array<{
      id?: number | null;
      title?: string | null;
      title_en?: string | null;
      summary?: string | null;
      summary_en?: string | null;
      thumbnail_path?: string | null;
      is_solitary?: boolean | null;
      is_hottest?: boolean | null;
      is_purchasable?: boolean | null;
      tax?: number | null;
      price?: number | null;
      price_before_discount?: number | null;
      status?: GeneralStatus | null;
      created_at?: any | null;
      updated_at?: any | null;
    } | null> | null;
  } | null;
};

export type GetContentsByCategoryDescriptorQueryVariables = Exact<{
  descriptor: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetContentsByCategoryDescriptorQuery = {
  getContentsByCategoryDescriptor?: {
    totalCount: number;
    data?: Array<{
      id?: number | null;
      title?: string | null;
      title_en?: string | null;
      text?: string | null;
      summary?: string | null;
      summary_en?: string | null;
      type?: ContentType | null;
      play_type?: ContentPlayType | null;
      status?: ContentStatus | null;
      minAge?: number | null;
      maxAge?: number | null;
      thumbnail_path?: string | null;
      index?: number | null;
      sex?: { id: number; sex: string } | null;
      categories?: {
        totalCount: number;
        data?: Array<{
          id?: number | null;
          name?: string | null;
          category_id?: number | null;
          descriptor?: string | null;
        } | null> | null;
      } | null;
      author?: {
        id?: number | null;
        first_name?: string | null;
        last_name?: string | null;
        profile_image?: string | null;
        specialty?: string | null;
        created_at?: any | null;
        updated_at?: any | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetPublishedContentByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type GetPublishedContentByIdQuery = {
  getPublishedContentById?: {
    id?: number | null;
    title?: string | null;
    title_en?: string | null;
    play_type?: ContentPlayType | null;
    text?: string | null;
    summary?: string | null;
    summary_en?: string | null;
    type?: ContentType | null;
    status?: ContentStatus | null;
    minAge?: number | null;
    maxAge?: number | null;
    thumbnail_path?: string | null;
    index?: number | null;
    sex?: { id: number; sex: string } | null;
    categories?: {
      totalCount: number;
      data?: Array<{
        id?: number | null;
        name?: string | null;
        descriptor?: string | null;
      } | null> | null;
    } | null;
    author?: {
      id?: number | null;
      first_name?: string | null;
      last_name?: string | null;
      profile_image?: string | null;
      specialty?: string | null;
      created_at?: any | null;
      updated_at?: any | null;
    } | null;
    file_object?: {
      id?: number | null;
      filename?: string | null;
      status?: FileObjectStatus | null;
    } | null;
    program?: { id?: number | null; title?: string | null; is_purchasable?: boolean | null } | null;
  } | null;
};

export type GetCategoryByDescriptorQueryVariables = Exact<{
  descriptor: Scalars['String']['input'];
}>;

export type GetCategoryByDescriptorQuery = {
  getCategoryByDescriptor?: {
    id?: number | null;
    name?: string | null;
    category_id?: number | null;
    description?: string | null;
    descriptor?: string | null;
    logo?: string | null;
    banner?: string | null;
    status?: number | null;
    created_at?: any | null;
    updated_at?: any | null;
  } | null;
};

export type GetFreePublishedContentsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetFreePublishedContentsQuery = {
  getFreePublishedContents?: {
    totalCount: number;
    data?: Array<{
      id?: number | null;
      title?: string | null;
      text?: string | null;
      title_en?: string | null;
      summary?: string | null;
      summary_en?: string | null;
      thumbnail_path?: string | null;
      type?: ContentType | null;
      status?: ContentStatus | null;
      minAge?: number | null;
      maxAge?: number | null;
      sex_id?: number | null;
      index?: number | null;
      author_id?: number | null;
      created_at?: any | null;
      updated_at?: any | null;
      sex?: { id: number; sex: string } | null;
      author?: {
        id?: number | null;
        first_name?: string | null;
        last_name?: string | null;
        profile_image?: string | null;
        specialty?: string | null;
        created_at?: any | null;
        updated_at?: any | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetContentsByProgramIdQueryVariables = Exact<{
  programId: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetContentsByProgramIdQuery = {
  getContentsByProgramId?: {
    totalCount: number;
    data?: Array<{
      id?: number | null;
      text?: string | null;
      title?: string | null;
      title_en?: string | null;
      summary?: string | null;
      summary_en?: string | null;
      is_hottest?: boolean | null;
      thumbnail_path?: string | null;
      type?: ContentType | null;
      minAge?: number | null;
      maxAge?: number | null;
      index?: number | null;
      created_at?: any | null;
      updated_at?: any | null;
      play_type?: ContentPlayType | null;
      sex?: { id: number; sex: string } | null;
      categories?: {
        data?: Array<{ id?: number | null; name?: string | null } | null> | null;
      } | null;
      author?: {
        id?: number | null;
        first_name?: string | null;
        last_name?: string | null;
        profile_image?: string | null;
        specialty?: string | null;
        created_at?: any | null;
        updated_at?: any | null;
      } | null;
      file_object?: {
        id?: number | null;
        filename?: string | null;
        fileUrl?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetConversationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetConversationsQuery = {
  getConversations: Array<{ id: number; name?: string | null; created_at?: any | null }>;
};

export type GetConversationMessagesQueryVariables = Exact<{
  conversationId: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetConversationMessagesQuery = {
  getMessages: Array<{
    id: number;
    text: string;
    sender_type: MessageSenderType;
    created_at?: any | null;
    suggestions?: Array<{
      start_time: number;
      end_time?: number | null;
      content_id?: string | null;
      filepath: string;
      title: string;
    } | null> | null;
  }>;
};

export type GetUserTokenBalanceQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserTokenBalanceQuery = { getUserTokenBalance: number };

export type SendMessageMutationVariables = Exact<{
  text: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SendMessageMutation = {
  sendMessage: {
    message: {
      id: number;
      text: string;
      sender_type: MessageSenderType;
      created_at?: any | null;
      suggestions?: Array<{
        start_time: number;
        end_time?: number | null;
        content_id?: string | null;
        filepath: string;
        title: string;
      } | null> | null;
    };
    conversation: { id: number; name?: string | null; created_at?: any | null };
  };
};

export type GetUserEventsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetUserEventsQuery = {
  getUserEvents?: {
    totalCount: number;
    data?: Array<{
      id?: number | null;
      title?: string | null;
      image?: string | null;
      link?: string | null;
      organizer?: string | null;
      organizer_image?: string | null;
      date?: any | null;
      status?: GeneralStatus | null;
      created_at?: any | null;
      updated_at?: any | null;
    } | null> | null;
  } | null;
};

export type CreateMyKidMutationVariables = Exact<{
  data: MyKidCreateArgs;
}>;

export type CreateMyKidMutation = { createMyKid?: { id: number } | null };

export type GetMyKidsQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyKidsQuery = {
  getMyKids?: {
    totalCount: number;
    data?: Array<{
      id: number;
      first_name?: string | null;
      last_name?: string | null;
      birthdate?: any | null;
      isOnlyChild?: number | null;
      childNumber?: number | null;
      gender?: number | null;
      status?: number | null;
      is_born?: number | null;
      week?: number | null;
      weight?: string | null;
      profile_image?: string | null;
      created_at?: any | null;
      updated_at?: any | null;
      parentType?: { id: number; name: string } | null;
    } | null> | null;
  } | null;
};

export type UpdateMyKidMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  data: MyKidUpdateArgs;
}>;

export type UpdateMyKidMutation = { updateMyKid?: { id: number } | null };

export type DeleteMyKidMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteMyKidMutation = { deleteMyKid?: { id: number } | null };

export type GetPageLayoutQueryVariables = Exact<{
  descriptor: Scalars['String']['input'];
}>;

export type GetPageLayoutQuery = {
  getPageLayout?: {
    rows?: Array<{
      title?: string | null;
      item_id?: string | null;
      url?: string | null;
      item_type?: PageRowItemType | null;
      data_type?: PageRowDataType | null;
      type?: PageLayoutType | null;
    } | null> | null;
  } | null;
};

export type GetUserPromotionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetUserPromotionsQuery = {
  getUserPromotions?: {
    totalCount: number;
    data?: Array<{
      id: number;
      title: string;
      image: string;
      order: number;
      description?: string | null;
      link?: string | null;
      status: GeneralStatus;
      created_at: any;
      updated_at: any;
    } | null> | null;
  } | null;
};

export type GetActiveProgramByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type GetActiveProgramByIdQuery = {
  getActiveProgramById?: {
    id?: number | null;
    title?: string | null;
    summary?: string | null;
    summary_en?: string | null;
    thumbnail_path?: string | null;
    is_solitary?: boolean | null;
    is_hottest?: boolean | null;
    is_purchasable?: boolean | null;
    price?: number | null;
    price_before_discount?: number | null;
    created_at?: any | null;
    updated_at?: any | null;
    categories?: Array<{
      id?: number | null;
      name?: string | null;
      descriptor?: string | null;
    } | null> | null;
  } | null;
};

export type GetProgramsByCategoryDescriptorQueryVariables = Exact<{
  descriptor: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetProgramsByCategoryDescriptorQuery = {
  getProgramsByCategoryDescriptor?: {
    totalCount: number;
    data?: Array<{
      id?: number | null;
      title?: string | null;
      title_en?: string | null;
      summary?: string | null;
      summary_en?: string | null;
      thumbnail_path?: string | null;
      is_solitary?: boolean | null;
      is_hottest?: boolean | null;
      status?: GeneralStatus | null;
      created_at?: any | null;
      updated_at?: any | null;
    } | null> | null;
  } | null;
};

export type PurchaseMutationVariables = Exact<{
  body: PurchaseInputs;
}>;

export type PurchaseMutation = {
  purchase?: {
    message?: string | null;
    new_balance?: number | null;
    transaction?: {
      id: string;
      amount: number;
      type: WalletTransactionType;
      status: WalletTransactionStatus;
      description?: string | null;
      reference?: string | null;
      metadata?: any | null;
      created_at?: any | null;
      updated_at?: any | null;
    } | null;
  } | null;
};

export type GetSearchResultsQueryVariables = Exact<{
  filter: Scalars['String']['input'];
}>;

export type GetSearchResultsQuery = {
  getSearchResult?: {
    categories?: Array<{
      id?: number | null;
      name?: string | null;
      category_id?: number | null;
      description?: string | null;
      descriptor?: string | null;
      logo?: string | null;
      banner?: string | null;
      status?: number | null;
      created_at?: any | null;
      updated_at?: any | null;
    } | null> | null;
    titleMatches?: Array<{
      id?: number | null;
      title?: string | null;
      text?: string | null;
      title_en?: string | null;
      summary?: string | null;
      summary_en?: string | null;
      thumbnail_path?: string | null;
      type?: ContentType | null;
      status?: ContentStatus | null;
      minAge?: number | null;
      maxAge?: number | null;
      sex_id?: number | null;
      index?: number | null;
      author_id?: number | null;
      created_at?: any | null;
      updated_at?: any | null;
      play_type?: ContentPlayType | null;
      categories?: {
        data?: Array<{ id?: number | null; name?: string | null } | null> | null;
      } | null;
    } | null> | null;
    contentMatches?: Array<{
      id?: number | null;
      title?: string | null;
      text?: string | null;
      title_en?: string | null;
      summary?: string | null;
      summary_en?: string | null;
      thumbnail_path?: string | null;
      type?: ContentType | null;
      status?: ContentStatus | null;
      minAge?: number | null;
      maxAge?: number | null;
      sex_id?: number | null;
      index?: number | null;
      author_id?: number | null;
      created_at?: any | null;
      updated_at?: any | null;
      categories?: {
        data?: Array<{ id?: number | null; name?: string | null } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetParentTypesQueryVariables = Exact<{
  filter: GetParentTypesFilter;
}>;

export type GetParentTypesQuery = {
  getParentTypes?: {
    totalCount: number;
    data?: Array<{ id: number; gender?: number | null; name: string }> | null;
  } | null;
};

export type GetPregnancyStatusesQueryVariables = Exact<{ [key: string]: never }>;

export type GetPregnancyStatusesQuery = {
  getPregnancyStatuses?: Array<{ id?: number | null; title?: string | null } | null> | null;
};

export type GetPlansQueryVariables = Exact<{ [key: string]: never }>;

export type GetPlansQuery = {
  getPlans?: {
    totalCount: number;
    data?: Array<{
      id: number;
      name: string;
      price: number;
      tax: number;
      price_before_discount?: number | null;
      duration_days: number;
      type: PlanType;
      description?: string | null;
      status: GeneralStatus;
      created_at: any;
      updated_at: any;
    } | null> | null;
  } | null;
};

export type GetPaymentGatewaysQueryVariables = Exact<{ [key: string]: never }>;

export type GetPaymentGatewaysQuery = {
  getPaymentGateways?: Array<{
    id?: number | null;
    name?: string | null;
    logo?: string | null;
  } | null> | null;
};

export type GetTokenPlansQueryVariables = Exact<{ [key: string]: never }>;

export type GetTokenPlansQuery = {
  getTokenPlans?: {
    totalCount: number;
    data?: Array<{
      id: number;
      count: number;
      name: string;
      price: number;
      tax: number;
      price_before_discount?: number | null;
      description?: string | null;
      status: GeneralStatus;
      created_at: any;
      updated_at: any;
    } | null> | null;
  } | null;
};

export type GetUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserQuery = {
  getProfile?: {
    id?: number | null;
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    mobile?: string | null;
    status?: number | null;
    gender?: number | null;
    created_at?: any | null;
    updated_at?: any | null;
    birthdate?: any | null;
    parent_type_id?: number | null;
    number_of_children?: number | null;
    pregnancy_status_id?: number | null;
    pregnancy_week?: number | null;
    game_notification_status?: number | null;
    activity_notification_status?: number | null;
  } | null;
};

export type UpdateUserMutationVariables = Exact<{
  data: ProfileUpdateArgs;
}>;

export type UpdateUserMutation = { updateProfile?: { id?: number | null } | null };

export type GetPurchasesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<PurchaseFilter>;
}>;

export type GetPurchasesQuery = {
  getMyPurchases?: {
    totalCount: number;
    data?: Array<{
      id: number;
      start_date?: any | null;
      end_date?: any | null;
      type: PurchaseType;
      status: PurchaseStatus;
      created_at: any;
      updated_at: any;
      plan?: {
        id: number;
        name: string;
        tax: number;
        price: number;
        price_before_discount?: number | null;
        duration_days: number;
        type: PlanType;
        description?: string | null;
        status: GeneralStatus;
      } | null;
      token_plan?: {
        id: number;
        count: number;
        name: string;
        tax: number;
        price: number;
        price_before_discount?: number | null;
        description?: string | null;
        status: GeneralStatus;
      } | null;
      program?: {
        id?: number | null;
        title?: string | null;
        title_en?: string | null;
        summary?: string | null;
        summary_en?: string | null;
        thumbnail_path?: string | null;
        is_solitary?: boolean | null;
        is_hottest?: boolean | null;
        is_purchasable?: boolean | null;
        tax?: number | null;
        price?: number | null;
        price_before_discount?: number | null;
        status?: GeneralStatus | null;
      } | null;
      voucher?: {
        id: number;
        code: string;
        discount_value: number;
        expiry_date?: any | null;
        status: VoucherStatus;
        type: VoucherType;
      } | null;
      bundle?: {
        id: number;
        title: string;
        title_en?: string | null;
        summary?: string | null;
        summary_en?: string | null;
        description?: string | null;
        thumbnail_path?: string | null;
        is_purchasable?: boolean | null;
        tax?: number | null;
        price?: number | null;
        price_before_discount?: number | null;
        status?: GeneralStatus | null;
      } | null;
      transaction: {
        id: string;
        amount: number;
        type: WalletTransactionType;
        status: WalletTransactionStatus;
        description?: string | null;
        reference?: string | null;
        metadata?: any | null;
      };
    } | null> | null;
  } | null;
};

export type UserHaveAccessToEntityQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  type: EntityType;
}>;

export type UserHaveAccessToEntityQuery = { userHaveAccessToEntity?: boolean | null };

export type CheckValidationVoucherQueryVariables = Exact<{
  code: Scalars['String']['input'];
  type: Array<VoucherType> | VoucherType;
}>;

export type CheckValidationVoucherQuery = {
  checkValidationVoucher?: {
    id: number;
    code: string;
    discount_value: number;
    expiry_date?: any | null;
    status: VoucherStatus;
    type: VoucherType;
    created_at: any;
    updated_at: any;
    plan?: {
      id: number;
      name: string;
      tax: number;
      price: number;
      price_before_discount?: number | null;
      duration_days: number;
      type: PlanType;
      description?: string | null;
      status: GeneralStatus;
      created_at: any;
      updated_at: any;
    } | null;
    token_plan?: {
      id: number;
      count: number;
      name: string;
      tax: number;
      price: number;
      price_before_discount?: number | null;
      description?: string | null;
      status: GeneralStatus;
      created_at: any;
      updated_at: any;
    } | null;
    programs?: Array<{
      id?: number | null;
      title?: string | null;
      title_en?: string | null;
      summary?: string | null;
      summary_en?: string | null;
      thumbnail_path?: string | null;
      is_solitary?: boolean | null;
      is_hottest?: boolean | null;
      is_purchasable?: boolean | null;
      tax?: number | null;
      price?: number | null;
      price_before_discount?: number | null;
      status?: GeneralStatus | null;
      created_at?: any | null;
      updated_at?: any | null;
    } | null> | null;
    bundles?: Array<{
      id: number;
      title: string;
      title_en?: string | null;
      summary?: string | null;
      summary_en?: string | null;
      description?: string | null;
      thumbnail_path?: string | null;
      is_purchasable?: boolean | null;
      tax?: number | null;
      price?: number | null;
      price_before_discount?: number | null;
      status?: GeneralStatus | null;
      created_at?: any | null;
      updated_at?: any | null;
    } | null> | null;
  } | null;
};

export type GetWalletQueryVariables = Exact<{ [key: string]: never }>;

export type GetWalletQuery = {
  getMyWallet?: {
    id?: string | null;
    balance?: number | null;
    currency?: string | null;
    created_at?: any | null;
    updated_at?: any | null;
  } | null;
};

export type GetWalletTransactionsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<WalletTransactionFilter>;
  sort?: InputMaybe<WalletTransactionOrderFields>;
}>;

export type GetWalletTransactionsQuery = {
  getWalletTransactions?: {
    totalCount?: number | null;
    data?: Array<{
      id: string;
      amount: number;
      type: WalletTransactionType;
      status: WalletTransactionStatus;
      description?: string | null;
      reference?: string | null;
      metadata?: any | null;
      created_at?: any | null;
      updated_at?: any | null;
    } | null> | null;
  } | null;
};

export type GetWalletTransactionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetWalletTransactionQuery = {
  getWalletTransactionById?: {
    id: string;
    amount: number;
    type: WalletTransactionType;
    status: WalletTransactionStatus;
    description?: string | null;
    reference?: string | null;
    metadata?: any | null;
    created_at?: any | null;
    updated_at?: any | null;
  } | null;
};

export type DepositWalletMutationVariables = Exact<{
  data: DepositArgs;
}>;

export type DepositWalletMutation = { depositToWallet?: { url: string; amount: number } | null };

export type GetWalletChargeConfigsQueryVariables = Exact<{ [key: string]: never }>;

export type GetWalletChargeConfigsQuery = {
  getWalletChargeConfigs?: Array<{ amount: number; descriptor: string } | null> | null;
};

export const RefreshTokenDocument = gql`
  mutation refreshToken {
    refreshToken {
      access_token
      refresh_token
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RefreshTokenMutationService extends Apollo.Mutation<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
> {
  override document = RefreshTokenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LogoutDocument = gql`
  mutation logout {
    logout
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LogoutMutationService extends Apollo.Mutation<
  LogoutMutation,
  LogoutMutationVariables
> {
  override document = LogoutDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestLoginDocument = gql`
  mutation requestLogin($mobile: String!) {
    requestLogin(mobile: $mobile) {
      message
      status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RequestLoginMutationService extends Apollo.Mutation<
  RequestLoginMutation,
  RequestLoginMutationVariables
> {
  override document = RequestLoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LoginWithCodeDocument = gql`
  mutation loginWithCode($mobile: String!, $code: String!) {
    loginWithCode(mobile: $mobile, code: $code) {
      access_token
      refresh_token
      is_setup
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LoginWithCodeMutationService extends Apollo.Mutation<
  LoginWithCodeMutation,
  LoginWithCodeMutationVariables
> {
  override document = LoginWithCodeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LoginWithTmtDocument = gql`
  mutation loginWithTmt {
    loginWithTmt {
      access_token
      refresh_token
      is_setup
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LoginWithTmtMutationService extends Apollo.Mutation<
  LoginWithTmtMutation,
  LoginWithTmtMutationVariables
> {
  override document = LoginWithTmtDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetMyDevicesWithTempTokenDocument = gql`
  query getMyDevicesWithTempToken {
    getMyDevicesWithTmt {
      id
      source
      user_agent
      ip_address
      visitor_id
      metadata
      created_at
      last_used_at
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMyDevicesWithTempTokenQueryService extends Apollo.Query<
  GetMyDevicesWithTempTokenQuery,
  GetMyDevicesWithTempTokenQueryVariables
> {
  override document = GetMyDevicesWithTempTokenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetMyDevicesDocument = gql`
  query getMyDevices {
    getMyDevices {
      id
      source
      user_agent
      ip_address
      visitor_id
      metadata
      created_at
      last_used_at
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMyDevicesQueryService extends Apollo.Query<
  GetMyDevicesQuery,
  GetMyDevicesQueryVariables
> {
  override document = GetMyDevicesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetVisitorIdDocument = gql`
  query getVisitorId {
    getVisitorId
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetVisitorIdQueryService extends Apollo.Query<
  GetVisitorIdQuery,
  GetVisitorIdQueryVariables
> {
  override document = GetVisitorIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TerminateDeviceSessionWithTempTokenDocument = gql`
  mutation terminateDeviceSessionWithTempToken($deviceId: ID!) {
    terminateDeviceWithTmt(deviceId: $deviceId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class TerminateDeviceSessionWithTempTokenMutationService extends Apollo.Mutation<
  TerminateDeviceSessionWithTempTokenMutation,
  TerminateDeviceSessionWithTempTokenMutationVariables
> {
  override document = TerminateDeviceSessionWithTempTokenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TerminateDeviceSessionDocument = gql`
  mutation terminateDeviceSession($deviceId: ID!) {
    terminateDevice(deviceId: $deviceId)
  }
`;

@Injectable({
  providedIn: 'root',
})
export class TerminateDeviceSessionMutationService extends Apollo.Mutation<
  TerminateDeviceSessionMutation,
  TerminateDeviceSessionMutationVariables
> {
  override document = TerminateDeviceSessionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RequestLoginWithGoogleDocument = gql`
  query requestLoginWithGoogle {
    requestLoginWithGoogle
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RequestLoginWithGoogleQueryService extends Apollo.Query<
  RequestLoginWithGoogleQuery,
  RequestLoginWithGoogleQueryVariables
> {
  override document = RequestLoginWithGoogleDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetBundlesDocument = gql`
  query getBundles($page: Int = 1, $filter: BundleFilter = {}, $orderBy: BundleOrderFields = {}) {
    getActiveBundles(page: $page, filter: $filter, orderBy: $orderBy) {
      data {
        id
        title
        title_en
        summary
        summary_en
        description
        thumbnail_path
        is_purchasable
        tax
        price
        price_before_discount
        status
        created_at
        updated_at
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetBundlesQueryService extends Apollo.Query<
  GetBundlesQuery,
  GetBundlesQueryVariables
> {
  override document = GetBundlesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetBundleByIdDocument = gql`
  query getBundleById($id: Int!) {
    getActiveBundleById(id: $id) {
      id
      title
      title_en
      summary
      summary_en
      description
      thumbnail_path
      is_purchasable
      tax
      price
      price_before_discount
      status
      created_at
      updated_at
      programs {
        id
        title
        title_en
        summary
        summary_en
        thumbnail_path
        is_solitary
        is_hottest
        is_purchasable
        tax
        price
        price_before_discount
        status
        created_at
        updated_at
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetBundleByIdQueryService extends Apollo.Query<
  GetBundleByIdQuery,
  GetBundleByIdQueryVariables
> {
  override document = GetBundleByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetContentsByCategoryDescriptorDocument = gql`
  query getContentsByCategoryDescriptor($descriptor: String!, $page: Int = 1) {
    getContentsByCategoryDescriptor(categoryDescriptor: $descriptor, page: $page) {
      totalCount
      data {
        id
        title
        title_en
        text
        summary
        summary_en
        type
        play_type
        status
        minAge
        maxAge
        thumbnail_path
        index
        sex {
          id
          sex
        }
        categories {
          data {
            id
            name
            category_id
            descriptor
          }
          totalCount
        }
        author {
          id
          first_name
          last_name
          profile_image
          specialty
          created_at
          updated_at
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetContentsByCategoryDescriptorQueryService extends Apollo.Query<
  GetContentsByCategoryDescriptorQuery,
  GetContentsByCategoryDescriptorQueryVariables
> {
  override document = GetContentsByCategoryDescriptorDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPublishedContentByIdDocument = gql`
  query getPublishedContentById($id: Int!) {
    getPublishedContentById(id: $id) {
      id
      title
      title_en
      play_type
      text
      summary
      summary_en
      type
      status
      minAge
      maxAge
      thumbnail_path
      index
      sex {
        id
        sex
      }
      categories {
        data {
          id
          name
          descriptor
        }
        totalCount
      }
      author {
        id
        first_name
        last_name
        profile_image
        specialty
        created_at
        updated_at
      }
      file_object {
        id
        filename
        status
      }
      program {
        id
        title
        is_purchasable
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPublishedContentByIdQueryService extends Apollo.Query<
  GetPublishedContentByIdQuery,
  GetPublishedContentByIdQueryVariables
> {
  override document = GetPublishedContentByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetCategoryByDescriptorDocument = gql`
  query getCategoryByDescriptor($descriptor: String!) {
    getCategoryByDescriptor(descriptor: $descriptor) {
      id
      name
      category_id
      description
      descriptor
      logo
      banner
      status
      created_at
      updated_at
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetCategoryByDescriptorQueryService extends Apollo.Query<
  GetCategoryByDescriptorQuery,
  GetCategoryByDescriptorQueryVariables
> {
  override document = GetCategoryByDescriptorDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetFreePublishedContentsDocument = gql`
  query getFreePublishedContents($page: Int = 1) {
    getFreePublishedContents(page: $page) {
      data {
        id
        title
        text
        title_en
        summary
        summary_en
        thumbnail_path
        type
        status
        minAge
        maxAge
        sex_id
        sex {
          id
          sex
        }
        author {
          id
          first_name
          last_name
          profile_image
          specialty
          created_at
          updated_at
        }
        index
        author_id
        created_at
        updated_at
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetFreePublishedContentsQueryService extends Apollo.Query<
  GetFreePublishedContentsQuery,
  GetFreePublishedContentsQueryVariables
> {
  override document = GetFreePublishedContentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetContentsByProgramIdDocument = gql`
  query getContentsByProgramId($programId: Int!, $page: Int = 1) {
    getContentsByProgramId(id: $programId, page: $page) {
      totalCount
      data {
        id
        text
        title
        title_en
        summary
        summary_en
        is_hottest
        thumbnail_path
        type
        minAge
        maxAge
        sex {
          id
          sex
        }
        index
        created_at
        updated_at
        categories {
          data {
            id
            name
          }
        }
        author {
          id
          first_name
          last_name
          profile_image
          specialty
          created_at
          updated_at
        }
        play_type
        file_object {
          id
          filename
          fileUrl
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetContentsByProgramIdQueryService extends Apollo.Query<
  GetContentsByProgramIdQuery,
  GetContentsByProgramIdQueryVariables
> {
  override document = GetContentsByProgramIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetConversationsDocument = gql`
  query getConversations {
    getConversations {
      id
      name
      created_at
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetConversationsQueryService extends Apollo.Query<
  GetConversationsQuery,
  GetConversationsQueryVariables
> {
  override document = GetConversationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetConversationMessagesDocument = gql`
  query getConversationMessages($conversationId: Int!, $page: Int = 1) {
    getMessages(conversationId: $conversationId, page: $page) {
      id
      text
      sender_type
      created_at
      suggestions {
        start_time
        end_time
        content_id
        filepath
        title
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetConversationMessagesQueryService extends Apollo.Query<
  GetConversationMessagesQuery,
  GetConversationMessagesQueryVariables
> {
  override document = GetConversationMessagesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserTokenBalanceDocument = gql`
  query getUserTokenBalance {
    getUserTokenBalance
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserTokenBalanceQueryService extends Apollo.Query<
  GetUserTokenBalanceQuery,
  GetUserTokenBalanceQueryVariables
> {
  override document = GetUserTokenBalanceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SendMessageDocument = gql`
  mutation sendMessage($text: String!, $conversationId: Int) {
    sendMessage(text: $text, conversationId: $conversationId) {
      message {
        id
        text
        sender_type
        created_at
        suggestions {
          start_time
          end_time
          content_id
          filepath
          title
        }
      }
      conversation {
        id
        name
        created_at
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SendMessageMutationService extends Apollo.Mutation<
  SendMessageMutation,
  SendMessageMutationVariables
> {
  override document = SendMessageDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserEventsDocument = gql`
  query getUserEvents($page: Int = 1) {
    getUserEvents(page: $page) {
      data {
        id
        title
        image
        link
        organizer
        organizer_image
        date
        status
        created_at
        updated_at
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserEventsQueryService extends Apollo.Query<
  GetUserEventsQuery,
  GetUserEventsQueryVariables
> {
  override document = GetUserEventsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateMyKidDocument = gql`
  mutation createMyKid($data: MyKidCreateArgs!) {
    createMyKid(kid: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateMyKidMutationService extends Apollo.Mutation<
  CreateMyKidMutation,
  CreateMyKidMutationVariables
> {
  override document = CreateMyKidDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetMyKidsDocument = gql`
  query getMyKids {
    getMyKids {
      data {
        id
        first_name
        last_name
        birthdate
        isOnlyChild
        childNumber
        gender
        status
        is_born
        week
        weight
        profile_image
        parentType {
          id
          name
        }
        created_at
        updated_at
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetMyKidsQueryService extends Apollo.Query<GetMyKidsQuery, GetMyKidsQueryVariables> {
  override document = GetMyKidsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateMyKidDocument = gql`
  mutation updateMyKid($id: Int!, $data: MyKidUpdateArgs!) {
    updateMyKid(id: $id, kid: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateMyKidMutationService extends Apollo.Mutation<
  UpdateMyKidMutation,
  UpdateMyKidMutationVariables
> {
  override document = UpdateMyKidDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteMyKidDocument = gql`
  mutation deleteMyKid($id: Int!) {
    deleteMyKid(id: $id) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteMyKidMutationService extends Apollo.Mutation<
  DeleteMyKidMutation,
  DeleteMyKidMutationVariables
> {
  override document = DeleteMyKidDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPageLayoutDocument = gql`
  query getPageLayout($descriptor: String!) {
    getPageLayout(descriptor: $descriptor) {
      rows {
        title
        item_id
        url
        item_type
        data_type
        type
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPageLayoutQueryService extends Apollo.Query<
  GetPageLayoutQuery,
  GetPageLayoutQueryVariables
> {
  override document = GetPageLayoutDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserPromotionsDocument = gql`
  query getUserPromotions($page: Int = 1) {
    getUserPromotions(page: $page) {
      data {
        id
        title
        image
        order
        description
        link
        status
        created_at
        updated_at
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserPromotionsQueryService extends Apollo.Query<
  GetUserPromotionsQuery,
  GetUserPromotionsQueryVariables
> {
  override document = GetUserPromotionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetActiveProgramByIdDocument = gql`
  query getActiveProgramById($id: Int!) {
    getActiveProgramById(id: $id) {
      id
      title
      summary
      summary_en
      thumbnail_path
      is_solitary
      is_hottest
      is_purchasable
      price
      price_before_discount
      created_at
      updated_at
      categories {
        id
        name
        descriptor
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetActiveProgramByIdQueryService extends Apollo.Query<
  GetActiveProgramByIdQuery,
  GetActiveProgramByIdQueryVariables
> {
  override document = GetActiveProgramByIdDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProgramsByCategoryDescriptorDocument = gql`
  query getProgramsByCategoryDescriptor($descriptor: String!, $page: Int = 1) {
    getProgramsByCategoryDescriptor(categoryDescriptor: $descriptor, page: $page) {
      data {
        id
        title
        title_en
        summary
        summary_en
        thumbnail_path
        is_solitary
        is_hottest
        status
        created_at
        updated_at
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetProgramsByCategoryDescriptorQueryService extends Apollo.Query<
  GetProgramsByCategoryDescriptorQuery,
  GetProgramsByCategoryDescriptorQueryVariables
> {
  override document = GetProgramsByCategoryDescriptorDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const PurchaseDocument = gql`
  mutation purchase($body: PurchaseInputs!) {
    purchase(body: $body) {
      message
      transaction {
        id
        amount
        type
        status
        description
        reference
        metadata
        created_at
        updated_at
      }
      new_balance
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class PurchaseMutationService extends Apollo.Mutation<
  PurchaseMutation,
  PurchaseMutationVariables
> {
  override document = PurchaseDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetSearchResultsDocument = gql`
  query getSearchResults($filter: String!) {
    getSearchResult(text: $filter) {
      categories {
        id
        name
        category_id
        description
        descriptor
        logo
        banner
        status
        created_at
        updated_at
      }
      titleMatches {
        id
        title
        text
        title_en
        summary
        summary_en
        thumbnail_path
        type
        status
        minAge
        maxAge
        sex_id
        index
        author_id
        created_at
        updated_at
        categories {
          data {
            id
            name
          }
        }
        play_type
      }
      contentMatches {
        id
        title
        text
        title_en
        summary
        summary_en
        thumbnail_path
        type
        status
        minAge
        maxAge
        sex_id
        index
        author_id
        created_at
        updated_at
        categories {
          data {
            id
            name
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetSearchResultsQueryService extends Apollo.Query<
  GetSearchResultsQuery,
  GetSearchResultsQueryVariables
> {
  override document = GetSearchResultsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetParentTypesDocument = gql`
  query getParentTypes($filter: GetParentTypesFilter!) {
    getParentTypes(filter: $filter) {
      data {
        id
        gender
        name
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetParentTypesQueryService extends Apollo.Query<
  GetParentTypesQuery,
  GetParentTypesQueryVariables
> {
  override document = GetParentTypesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPregnancyStatusesDocument = gql`
  query getPregnancyStatuses {
    getPregnancyStatuses {
      id
      title
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPregnancyStatusesQueryService extends Apollo.Query<
  GetPregnancyStatusesQuery,
  GetPregnancyStatusesQueryVariables
> {
  override document = GetPregnancyStatusesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPlansDocument = gql`
  query getPlans {
    getPlans {
      data {
        id
        name
        price
        tax
        price_before_discount
        duration_days
        type
        description
        status
        created_at
        updated_at
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPlansQueryService extends Apollo.Query<GetPlansQuery, GetPlansQueryVariables> {
  override document = GetPlansDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPaymentGatewaysDocument = gql`
  query getPaymentGateways {
    getPaymentGateways {
      id
      name
      logo
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPaymentGatewaysQueryService extends Apollo.Query<
  GetPaymentGatewaysQuery,
  GetPaymentGatewaysQueryVariables
> {
  override document = GetPaymentGatewaysDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetTokenPlansDocument = gql`
  query getTokenPlans {
    getTokenPlans {
      data {
        id
        count
        name
        price
        tax
        price_before_discount
        description
        status
        created_at
        updated_at
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetTokenPlansQueryService extends Apollo.Query<
  GetTokenPlansQuery,
  GetTokenPlansQueryVariables
> {
  override document = GetTokenPlansDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetUserDocument = gql`
  query getUser {
    getProfile {
      id
      first_name
      last_name
      email
      mobile
      status
      gender
      created_at
      updated_at
      birthdate
      parent_type_id
      number_of_children
      pregnancy_status_id
      pregnancy_week
      game_notification_status
      activity_notification_status
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetUserQueryService extends Apollo.Query<GetUserQuery, GetUserQueryVariables> {
  override document = GetUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateUserDocument = gql`
  mutation updateUser($data: ProfileUpdateArgs!) {
    updateProfile(data: $data) {
      id
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateUserMutationService extends Apollo.Mutation<
  UpdateUserMutation,
  UpdateUserMutationVariables
> {
  override document = UpdateUserDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetPurchasesDocument = gql`
  query getPurchases($page: Int = 1, $filters: PurchaseFilter = {}) {
    getMyPurchases(page: $page, filter: $filters) {
      data {
        id
        start_date
        end_date
        type
        status
        created_at
        updated_at
        plan {
          id
          name
          tax
          price
          price_before_discount
          duration_days
          type
          description
          status
        }
        token_plan {
          id
          count
          name
          tax
          price
          price_before_discount
          description
          status
        }
        program {
          id
          title
          title_en
          summary
          summary_en
          thumbnail_path
          is_solitary
          is_hottest
          is_purchasable
          tax
          price
          price_before_discount
          status
        }
        voucher {
          id
          code
          discount_value
          expiry_date
          status
          type
        }
        bundle {
          id
          title
          title_en
          summary
          summary_en
          description
          thumbnail_path
          is_purchasable
          tax
          price
          price_before_discount
          status
        }
        transaction {
          id
          amount
          type
          status
          description
          reference
          metadata
        }
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetPurchasesQueryService extends Apollo.Query<
  GetPurchasesQuery,
  GetPurchasesQueryVariables
> {
  override document = GetPurchasesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UserHaveAccessToEntityDocument = gql`
  query userHaveAccessToEntity($id: Int!, $type: EntityType!) {
    userHaveAccessToEntity(body: { entityId: $id, entityType: $type })
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UserHaveAccessToEntityQueryService extends Apollo.Query<
  UserHaveAccessToEntityQuery,
  UserHaveAccessToEntityQueryVariables
> {
  override document = UserHaveAccessToEntityDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CheckValidationVoucherDocument = gql`
  query checkValidationVoucher($code: String!, $type: [VoucherType!]!) {
    checkValidationVoucher(code: $code, type: $type) {
      id
      code
      discount_value
      expiry_date
      status
      type
      created_at
      updated_at
      plan {
        id
        name
        tax
        price
        price_before_discount
        duration_days
        type
        description
        status
        created_at
        updated_at
      }
      token_plan {
        id
        count
        name
        tax
        price
        price_before_discount
        description
        status
        created_at
        updated_at
      }
      programs {
        id
        title
        title_en
        summary
        summary_en
        thumbnail_path
        is_solitary
        is_hottest
        is_purchasable
        tax
        price
        price_before_discount
        status
        created_at
        updated_at
      }
      bundles {
        id
        title
        title_en
        summary
        summary_en
        description
        thumbnail_path
        is_purchasable
        tax
        price
        price_before_discount
        status
        created_at
        updated_at
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CheckValidationVoucherQueryService extends Apollo.Query<
  CheckValidationVoucherQuery,
  CheckValidationVoucherQueryVariables
> {
  override document = CheckValidationVoucherDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetWalletDocument = gql`
  query getWallet {
    getMyWallet {
      id
      balance
      currency
      created_at
      updated_at
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetWalletQueryService extends Apollo.Query<GetWalletQuery, GetWalletQueryVariables> {
  override document = GetWalletDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetWalletTransactionsDocument = gql`
  query getWalletTransactions(
    $page: Int = 1
    $filters: WalletTransactionFilter = {}
    $sort: WalletTransactionOrderFields = {}
  ) {
    getWalletTransactions(page: $page, filter: $filters, orderBy: $sort) {
      data {
        id
        amount
        type
        status
        description
        reference
        metadata
        created_at
        updated_at
      }
      totalCount
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetWalletTransactionsQueryService extends Apollo.Query<
  GetWalletTransactionsQuery,
  GetWalletTransactionsQueryVariables
> {
  override document = GetWalletTransactionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetWalletTransactionDocument = gql`
  query getWalletTransaction($id: String!) {
    getWalletTransactionById(id: $id) {
      id
      amount
      type
      status
      description
      reference
      metadata
      created_at
      updated_at
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetWalletTransactionQueryService extends Apollo.Query<
  GetWalletTransactionQuery,
  GetWalletTransactionQueryVariables
> {
  override document = GetWalletTransactionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DepositWalletDocument = gql`
  mutation depositWallet($data: DepositArgs!) {
    depositToWallet(data: $data) {
      url
      amount
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DepositWalletMutationService extends Apollo.Mutation<
  DepositWalletMutation,
  DepositWalletMutationVariables
> {
  override document = DepositWalletDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetWalletChargeConfigsDocument = gql`
  query getWalletChargeConfigs {
    getWalletChargeConfigs {
      amount
      descriptor
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetWalletChargeConfigsQueryService extends Apollo.Query<
  GetWalletChargeConfigsQuery,
  GetWalletChargeConfigsQueryVariables
> {
  override document = GetWalletChargeConfigsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
